import React, { useEffect } from 'react';
import { getAutoSaveHistory } from 'api/treatment';
import { IAutoSaveInfo, EAutoSaveBusinessType } from 'types/treatment';
import dayjs from 'dayjs';

interface Props {
    businessId: number;
    businessType?: EAutoSaveBusinessType;
    autoFetch?: boolean; // 是否自动获取数据
}

const useVersionHistory = (props: Props): [IAutoSaveInfo[], boolean, (businessId: number, businessType: EAutoSaveBusinessType) => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<IAutoSaveInfo[]>([]);

    const fetchData = async (businessId: number, businessType: EAutoSaveBusinessType) => {
        if (loading || !businessId || !businessType) return;
        try {
            setLoading(true);
            const result = await getAutoSaveHistory({ businessId, businessType, pageNum: 1, pageSize: 1000, updateAt: dayjs().startOf('day').toISOString() });
            if (!result.error) {
                const resData = result?.data?.data?.records || [];
                setData(resData);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    React.useEffect(() => {
        if (props.autoFetch && props.businessType && props.businessId) {
            fetchData(props.businessId, props.businessType);
        }
    }, [props.autoFetch, props.businessId, props.businessType]);

    return [data, loading, fetchData];
};

export default useVersionHistory;
